<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile";
import ModalMedia from '@/components/widgets/modalMedia'

// Services
import UsersDataService from "@/services/UsersDataService";
import MediaDataService from "@/services/MediaDataService";

// Helpers
import Storage from "@/helpers/storage";
import UserUtils from '@/helpers/users';
import DateUtils from '@/helpers/date';
import HelperUtils from '@/helpers/helper';
import {authComputed} from "@/state/helpers";

// External Components
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import countriesISO from "i18n-iso-countries";
import isEmpty from "is-empty";
import Switches from "vue-switches";
import imageCompression from "browser-image-compression";
import StorageUtils from "../../../helpers/storage";
import {PinturaEditorModal} from "@pqina/vue-pintura/vue-2";
import {
  // editor
  createDefaultImageReader,
  createDefaultImageWriter,
  createDefaultImageScrambler,
  createDefaultShapePreprocessor,

  // plugins
  setPlugins,
  plugin_crop,
  plugin_resize,
  plugin_filter,
  plugin_filter_defaults,
  plugin_finetune,
  plugin_finetune_defaults,
  markup_editor_defaults,
  plugin_redact,
} from '@pqina/pintura';

import locale_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/core/fr_FR.js';
// each plugin has a separate locale file
import locale_crop_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/crop/fr_FR.js';
import locale_redact_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/redact/fr_FR.js';
import locale_filter_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/filter/fr_FR.js';
import locale_finetune_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/finetune/fr_FR.js';
import locale_resize_fr_FR from '../../../../node_modules/@pqina/pintura/locale/fr_FR/resize/fr_FR.js';

const localeEditor = {
  ...locale_fr_FR,
  ...locale_crop_fr_FR,
  ...locale_redact_fr_FR,
  ...locale_filter_fr_FR,
  ...locale_finetune_fr_FR,
  ...locale_resize_fr_FR,
};

localeEditor.redactLabel = "Censurer";


setPlugins(plugin_crop, plugin_resize, plugin_finetune, plugin_filter, plugin_redact);

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Beautiful Users",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    UserProfile,
    PageHeader,
    VueTabs,
    Switches,
    VTab,
    CoolLightBox,
    PinturaEditorModal,
    ModalMedia
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...UserUtils,
    ...HelperUtils,
    ...DateUtils,
    isEmpty,

    getCountry(user) {
      return UserUtils.getCountryName(countriesISO, user.country.toUpperCase(), this.$i18n.locale)
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      params["filtersType"] = this.filtersType.selected;

      return params;
    },

    handleFilterChange() {
      this.pageSelected = 1;
      this.loadBeautifulUsers();
    },

    handlePageChange(value) {
      this.pageSelected = value;
      this.loadBeautifulUsers();
    },

    getImage(userId, mediaId, elt) {
      return Storage.getUserMedia(userId, mediaId, elt);
    },

    getMediaThumb() {
      if (this.users.length > 0)
        this.users.forEach(user => {
          if (user.media && user.media.length > 0) {
            user.media.forEach(media => {

              media.src = '';
              media.thumb = '';
              media.title =  media.mediaId;
              media.description = media.mediaId + ' #'+user.userId;
              media.isVideo = false;
              media.isValid = true;
              media.userId = user.userId;

              const that = this;
              const mediaPromise = [];

              mediaPromise.push(Storage.getUserMediaUrl(user.userId, media.mediaId));
              mediaPromise.push(Storage.getUserMediaUrl(user.userId, media.thumbFileName));
              /*if (this.filtersType.selected !== "A")
                mediaPromise.push(Storage.getUserMediaUrl(user.userId, media.mediaId));*/

              Promise.all(mediaPromise).then(value => {
                media.src = value[0];
                media.thumb = value[1];
                /*if (value.length === 3)
                  media.srcCrop = value[2];*/

                let img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = function() {
                  media.width = img.width;
                  media.height = img.height;
                  media.imgObj = img;
                  that.media[`${media.userId}-${media.mediaId}`] = media;
                };
                img.src = media.src;
                const eltMedia = document.getElementById("beautiful-" + media.userId + "-" + media.mediaId);
                const eltMediaThumb = document.getElementById("beautiful-" + media.userId + "-thumb-" + media.mediaId);
                eltMedia.setAttribute('src', media.src);
                eltMediaThumb.setAttribute('src', media.thumb);
                /*if (this.filtersType.selected !== "A") {
                  const eltMediaCrop = document.getElementById("beautiful-" + media.userId + "-crop-" + media.mediaId);
                  eltMediaCrop.setAttribute('src', media.srcCrop);
                }*/
              });
            });
          }
        });
    },

    normalize(user) {
      user.isAccepted = user.isAccepted === 1;
      return user;
    },

    loadBeautifulUsers() {
      const params = this.getRequestParams(
          this.pageSelected,
          this.pageSizes.selected,
      );

      this.isLoading = true;
      this.users = [];
      UsersDataService.getBeautifulUsers(params)
          .then(response => {
            const { items, totalItems } = response.data;
            const users = [];
            if (items.length > 0) {
              for (const item of items) {
                users.push(this.normalize(item));
              }
            }

            this.users = users;
            this.count = totalItems;
            this.getMediaThumb();
            this.isLoading = false;
          })
          .catch(error => {
            this.isLoading = false;
            window.console.error(error);
            this.$toast.error(error.message);
          })
    },

    setReviewed() {
      this.isProcessing = true;

      const reviewedList = [];
      this.users.forEach(result => {
        reviewedList.push({
          userId: result.userId,
          /*media: JSON.stringify(result.media),*/
          isAccepted: result.isAccepted === true,
        })
      });

      const params = {
        reviewedList: reviewedList
      };

      return UsersDataService
          .reviewBeautifulUsers(params)
          .then(() => {
            this.page = 1;
            this.isProcessing = false;
            this.loadBeautifulUsers();
          })
          .catch((error) => {
            this.isProcessing = false;
            this.$toast.error(error.toString());
            window.console.error(error);
          });
    },

    /**
     * Edit MEDIA SECTION
     */

    editClick(index) {
      this.editor.media = this.media[index];
      this.editor.visible = true;
    },

    closeModal() {
      this.$refs.mediaModal.closeModal();
    },

    handleEditModalShow() {
      window.console.log("handleEditModalShow");
    },

    handleEditModalClose() {
      window.console.log("handleEditModalClose");
    },

    handleEditModalLoad(event) {
      window.console.log("handleEditModalLoad");
      window.console.log(event);
    },

    handleCompressMedia(progress) {
      this.editor.progressCompress = progress;
      // window.console.log(`handleCompressMedia ${progress}`);
    },

    async compressMedia(file, options) {
      try {
        this.editor.progressCompress = 0;
        const compressedFile = await imageCompression(file, options);
        window.console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        window.console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        this.editor.progressCompress = 100;
        return compressedFile;
      } catch (error) {
        window.console.error(error);
        this.editor.progressCompress = 100;
        return null;
      }
    },

    async handleEditModalProcess(event) {
      window.console.log("handleEditModalProcess");
      window.console.log(event);
      this.$refs.mediaModal.openModal();
      this.editor.processing = true;
      this.editor.processingType = "compress";
      let compressedFile = await this.compressMedia(event.dest, {
        fileType: 'image/jpeg',
        alwaysKeepResolution: true,
        onProgress: this.handleCompressMedia
      });

      if (compressedFile === null) {
        compressedFile = event.dest;
      }

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        window.console.log("readAsDataURL ready");
        this.validEditMedia(reader.result);
      });
      reader.addEventListener('error', () => {
        window.console.error(reader.error);
      });
      reader.readAsDataURL(compressedFile);
    },

    validEditMedia(dataUrl) {
      const img  = new Image();
      img.addEventListener("load", async () => {
        window.console.log("image dataUrl loaded");
        this.editor.result.width = img.width;
        this.editor.result.height = img.height;
        this.editor.processingType = "upload";
        await UserUtils.deleteOldMediaBeforeReupload(this.editor.media.userId, this.editor.media);
        const uploadTask = StorageUtils.uploadMediaFromDataURL(this.editor.media.userId, this.editor.media.mediaId, dataUrl);
        uploadTask.on('state_changed',
            (snapshot) => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              this.editor.progressUpload = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            (error) => {
              window.console.error("uploadMediaFromDataURL error", error);
              this.closeModal();
              this.$toast.error(error.message);
            },
            async () => {
              window.console.log("uploadMediaFromDataURL success");
              // Handle successful uploads on complete
              try {
                this.editor.progressUpload = 100;

                let idx = `${this.editor.media.userId}-${this.editor.media.mediaId}`;
                this.$toast.success(this.$t('media.media_transform_success'));

                this.media[idx].width = this.editor.result.width;
                this.media[idx].height = this.editor.result.height;
                this.editor.processingType = "refresh";
                await this.reloadImg(this.media[idx].srcCrop);
                this.finishEdit();
                /*
                MediaDataService.generateFaceThumbnail({
                  mediaId: this.editor.media.mediaId,
                  userId: this.editor.media.userId,
                })
                    .then(response => {
                      const {urls} = response.data;
                      this.editor.processingType = "thumbnail";
                      this.editor.thumbnailNew = urls.new;
                      this.editor.thumbnailOld = urls.old;
                    })
                    .catch(error => {
                      window.console.error(error);
                      this.$toast.error("Generate new Thumbnail failed !");
                      this.finishEdit();
                    });*/
              }
              catch (error) {
                window.console.error("upload-success error", error);
              }
            }
        );
      });
      img.src = dataUrl;
    },

    async reloadImg(url) {
      await fetch(url, { cache: 'reload', mode: 'no-cors' })
      document.body.querySelectorAll(`img[src='${url}']`)
          .forEach(img => img.src = url)
    },

    finishEdit() {
      this.editor.processing = false;
      this.editor.processingType = "";
      this.editor.media = null;
      this.editor.thumbnailOld = "";
      this.editor.thumbnailNew = "";
      this.closeModal();
    },

    keepNewMediaThumb() {
      MediaDataService.keepNewThumbnail({
        userId: this.editor.media.userId,
        mediaId: this.editor.media.mediaId,
      })
          .then(async () => {
            const eltMediaThumb = document.getElementById("beautiful-" + this.editor.media.userId + "-thumb-" + this.editor.media.mediaId);
            await fetch(this.editor.thumbnailNew, { cache: 'reload', mode: 'no-cors' })
            eltMediaThumb.setAttribute("src", this.editor.thumbnailNew);
            window.console.log("Old Thumbnail deleted");
            this.finishEdit();
          })
          .catch((error) => {
            window.console.error("Old Thumbnail removing failed", error);
            this.finishEdit();
          });
    },

    keepOldMediaThumb() {
      this.editor.processingType = "keep";
      MediaDataService.keepOldThumbnail({
        mediaId: this.editor.media.mediaId,
        userId: this.editor.media.userId,
      })
          .then(() => {
            this.this.finishEdit();
          })
          .catch((error) => {
            window.console.error(error);
            this.$toast.error("Keep old thumbnail failed !");
            this.finishEdit();
          })
    },


    /**
     * Show USER SECTION
     */

    openUserPane() {
      if (!this.isUserPaneDisplayed) {
        this.isUserPaneDisplayed = true;
      }
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(user) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === user.userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(user.userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+user.userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== user.userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = user.userId; }, 100);
      }
    },

    showMedia(userId, mediaId, type) {
      Storage.getUserMediaUrl(userId, mediaId)
        .then((url) => {
          const media = {
            "id": 1,
            "userId": userId,
            "mediaId": mediaId,
            "createdAt":"",
            "typeMedia": type,
            "src": url,
            "title":"1/1",
          };

          this.showUserMedia([media], 0);
        });
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    },
  },

  data() {
    return {
      isLoading: false,
      userMedia: {
        media: [],
        index: -1
      },
      optionsContext: [
        {
          name: this.$t("show_user"),
          value: 'show'
        },
        {
          type: "divider"
        },
        {
          name: "Terminer",
          value: 'process',
        },
      ],
      isProcessingAction: false,
      users: [],
      media: {},
      isProcessing: false,
      userTabs:[],
      userTabsActive: '',
      count: 0,
      photos:[],
      title: this.$t("menuitems.members.beautiful_users"),
      pageSelected: 1,
      pageSizes: {
        options: ['1', '20', '50', '100'],
        selected: '50'
      },
      filtersType: {
        selected: 'W',
        options: [
          {
            value: "W",
            text: "To Review"
          },
          {
            value: "A",
            text: "Accepted"
          },
          {
            value: "D",
            text: "Declined"
          }
        ]
      },
      isUserPaneDisplayed: false,

      editor: {
        // defaults
        editorProps: {
          imageReader: createDefaultImageReader(),
          imageWriter: createDefaultImageWriter(),
          shapePreprocessor: createDefaultShapePreprocessor(),

          ...plugin_finetune_defaults,
          ...plugin_filter_defaults,
          ...markup_editor_defaults,

          locale: localeEditor,
        },
        cropSelectPresetOptions: [
          [
              'Ratios',
              [
                [10 / 16, '10:16'],
                [undefined, 'Custom'],
              ],
          ],
        ],

        resizeSizePresetOptions: [
          [undefined, 'Auto'],
          [[600, 960], '600x960'],
        ],

        imageScrambler: createDefaultImageScrambler({ scrambleAmount: 5 }),
        media: null,
        visible: false,
        processing: false,
        processingType: "",
        progressUpload: 0,
        progressCompress: 0,
        thumbnailNew: "",
        thumbnailOld: "",
        result: {
          width: 100,
          height:200,
        }
      }
    };
  },

  created() {
    countriesISO.registerLocale(require("i18n-iso-countries/langs/"+this.$i18n.locale+".json"));
    this.loadBeautifulUsers();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- filters -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body row">
              <b-form-row>
                <b-select :disabled="isLoading" class="form-select w-auto" v-model="filtersType.selected" @change="handleFilterChange">
                  <option v-for="filterType in filtersType.options" :key="filterType.value" :value="filterType.value">{{ filterType.text }}</option>
                </b-select>
              </b-form-row>
            </div>
          </div>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <div class="col-lg-auto col-12">
          <!-- Display settings -->
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleFilterChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
          {{ count }} {{ $t('resultsCount') }}
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="pageSelected"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="users-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- Result list -->
      <div class="row" v-if="!isLoading && users.length > 0">
        <div class="table-responsive">
          <table
              id="users-list"
              class="table project-list-table table-centered table-borderless align-middle">
            <thead class="table-light">
            <tr>
              <th scope="col">User</th>
              <th scope="col">Medias</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" :key="user.userId">
              <td valign="top">
                <p class="text-muted font-size-12 mb-2"  @click="showUser(user)">
                  <b>{{ user.name }}</b><br>
                  {{ getAge(user.birth) }}<br>
                  {{ user.origin }}<br>
                  <br><small>{{ user.userId }}</small>
                </p>
                <switches v-model="user.isAccepted" type-bold="true" color="info" class="mb-0 mt-3"></switches>
              </td>
              <td>
                <div class="row">
                  <div class="col-auto" v-for="media in user.media" :key="media.mediaId">
                    <a href="javascript: void(0);" @click="showMedia(user.userId, media.thumbFileName, 0)" class="d-inline-block">
                      <img :id="'beautiful-'+user.userId + '-thumb-'+media.mediaId" width="80" class="rounded-circle avatar-md"  />
                    </a>

                    <a href="javascript: void(0);" @click="showMedia(user.userId, media.mediaId, 0)" class="d-block mt-2">
                      <img :id="'beautiful-'+user.userId + '-'+media.mediaId" width="300" />
                    </a>

                    <!--<img v-if="filtersType.selected !== 'A'" class="d-block mt-2" :id="'beautiful-'+user.userId + '-crop-'+media.mediaId" style="width:300px;height:480px;object-fit:cover;" /> -->

                    <b-button class="mt-2" variant="outline-secondary" @click="editClick(`${user.userId}-${media.mediaId}`)" v-show="filtersType.selected !== 'A'">
                      <b-icon icon="pencil-fill" scale="1"></b-icon> MODIFIER
                    </b-button>

                  </div>
                </div>
              </td>

            </tr>
            </tbody>
          </table>
        </div>

        <div class="align-content-center mt-3 mb-3">
          <b-button
              v-show="!isProcessing && users.length > 0 "
              @click="setReviewed"
              variant="success">
            <i class="bx bx-trending-up"></i> {{ $t("valid") }}
          </b-button>

          <div class="status" v-show="isProcessing">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && users.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No profiles updates found. Try later.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleFilterChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="pageSelected"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="users-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>

    <b-sidebar
        id="sidebar-right" right
        v-model="isUserPaneDisplayed"
      >
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia"
              >
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

    <!-- Edit Image -->
    <PinturaEditorModal
        v-bind="editor.editorProps"
        v-if="editor.visible"
        :src="editor.media.src"
        :imageScrambler="editor.imageScrambler"
        :cropEnableButtonFlipVertical="true"
        :cropEnableButtonRotateRight="true"
        :cropEnableInfoIndicator="true"
        cropActiveTransformTool="zoom"
        :cropSelectPresetOptions="editor.cropSelectPresetOptions"
        cropInteractionFocus="image"
        :resizeSizePresetOptions="editor.resizeSizePresetOptions"

        @pintura:hide="editor.visible = false"
        @pintura:show="handleEditModalShow()"
        @pintura:close="handleEditModalClose()"
        @pintura:load="handleEditModalLoad($event)"
        @pintura:process="handleEditModalProcess($event)"
    />

    <!-- Modal Media popup -->
    <modalMedia ref="mediaModal">
      <template v-slot:body>
        <div v-show="editor.processing" class="card" style="min-width: 250px;min-height: 200px">
          <h5 class="p-5 text-center text-primary">Processing <span>{{ editor.processingType }}</span></h5>
          <div class="modalValidLoading" v-show="editor.processingType === 'keep'">
            <vue-ellipse-progress
                :loading="editor.processingType === 'keep'"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
          <div class="" v-show="editor.processingType === 'thumbnail' ">
            <div class="row card-body">
              <div class="col-lg-6 col-12  text-center align-content-center">
                <p>OLD</p>
                <img :src="editor.thumbnailOld" width="150" height="150" />
                <br>
                <b-button
                    class="mt-2"
                    @click="keepOldMediaThumb"
                    variant="outline-danger">
                  {{ $t("media.keep_old_thumb") }}
                </b-button>
              </div>
              <div class="col-lg-6 col-12 text-center align-content-center">
                <p>NEW</p>
                <img :src="editor.thumbnailNew" width="150" height="150" />
                <br>
                <b-button
                    class="mt-2"
                    @click="keepNewMediaThumb"
                    variant="outline-success">
                  {{ $t("media.keep_new_thumb") }}
                </b-button>
              </div>
            </div>
          </div>
          <div class="modalValidLoading" v-show="editor.processingType === 'compress'">
            <vue-ellipse-progress
                v-show="editor.processingType === 'compress'"
                :progress="editor.progressCompress"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
          <div class="modalValidLoading" v-show="editor.processingType === 'upload'">
            <vue-ellipse-progress
                v-show="editor.processingType === 'upload'"
                :progress="editor.progressUpload"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#fff"
                :size="70"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>
        </div>
      </template>
    </modalMedia>

  </Layout>
</template>

<style>
@import '../../../../node_modules/@pqina/pintura/pintura.css';

  .cursor-pointer {
    cursor:pointer;
  }

  .modalValidLoading {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 10px;
  }

  .modalValidLoading > div {
    position: relative;
    width: 100px;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
  }

  .avatar-sm {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .gender-img {
    max-width: 30px;
    margin-right: 10px;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
